import gql from "graphql-tag";
import { QueryHookOptions, useQuery } from "@apollo/client";

import { ReportAnswerFragment, REPORT_ANSWER_FRAGMENT } from "../../fragments";
import { Collection, ReportAnswersQueryVariables } from "../../types";

export const GET_REPORT_ANSWERS = gql`
  query getReportAnswers(
    $skillIds: [ID!]
    $type: [String!]
    $templateQuestionDigest: [String!]
    $isCheckedReport: Boolean
  ) {
    reportAnswers(
      skillIds: $skillIds
      type: $type
      templateQuestionDigest: $templateQuestionDigest
      isCheckedReport: $isCheckedReport
    ) {
      collection {
        ...ReportAnswerFragment
      }
    }
  }
  ${REPORT_ANSWER_FRAGMENT}
`;

export type ReportAnswersData = {
  reportAnswers: Collection<ReportAnswerFragment>;
};

export default (
  options?: QueryHookOptions<ReportAnswersData, ReportAnswersQueryVariables>
) => {
  return useQuery<ReportAnswersData, ReportAnswersQueryVariables>(
    GET_REPORT_ANSWERS,
    options
  );
};
